import { useState } from "react";
import { useSelector } from "react-redux";
import AutoCompleteSelect from "../../../../../../components/AutoCompleteSelect/AutoComplete";
import RadioButton from "../../../../../../components/RadioButton/RadioButton";
import TextInput from "../../../../../../components/TextInput/TextInput";
import {
  useFinalSubmitMutation,
  useProposalEnquiry,
} from "../../../../../../services/ProposalServices";
import { onInputPhone, uppercase } from "../../../../../../utils/onInput";
import { yesNoItems } from "../../../../../../utils/YesNoRadioItems";
import { InputWrapper } from "../../../../ProposalForm.style";
import ClosedForm from "../ClosedForm/ClosedForm";
import validation from "./ckycDetailsValidation";
import moment from "moment";
import DatePicker from "../../../../../../components/DatePicker/DatePicker";
import Loader from "../../../../../../components/Loader/Loader";
import Tooltip from "@mui/material/Tooltip";
const CKYCDetails = () => {
  const { proposalData } = useSelector((state) => state.proposal);
  const [errors, setErrors] = useState({});
  const { product } = useProposalEnquiry();

  const [formData, setFormData] = useState({
    ckyc_no: proposalData?.ckyc_no,
    ckyc_dob: proposalData?.ckyc_dob,
    ckyc_pan_no: proposalData?.ckyc_pan_no,
    pan_dob: proposalData?.pan_dob,
    aadhaar_number: proposalData?.aadhaar_number,
    full_name: proposalData?.full_name,
    aadhaar_dob: proposalData?.aadhaar_dob,
    ckyc_gender: proposalData?.ckyc_gender,
    dl_number: proposalData?.dl_number,
    dl_dob: proposalData?.dl_dob,
    file_number: proposalData?.file_number,
    passport_dob: proposalData?.passport_dob,
    photo_doc: proposalData?.photo_doc ? proposalData?.photo_doc : undefined,
    method_of_verification: "",
    // POI_Type: proposalData?.POI_Type,
    // POI_ID: proposalData?.POI_ID,
    // POI_DocumentFile: proposalData?.POI_DocumentFile,
    // POA_Type: proposalData?.POA_Type,
    // POA_ID: proposalData?.POA_ID,
    // POA_DocumentFile: proposalData?.POA_DocumentFile,
    // Insured_photo: proposalData?.Insured_photo
    //   ? proposalData?.Insured_photo
    //   : "undefined",
    pan_no: proposalData?.pan_no ? proposalData?.pan_no : "",
    address_proof_front_doc: proposalData?.address_proof_front_doc,
    address_proof_back_doc: proposalData?.address_proof_back_doc,
    is_ckyc_no: "",
  });

  const { finalSubmit, isLoading } = useFinalSubmitMutation();
  const [error, setError] = useState({});
  const onChange = async (name, data) => {
    setFormData((prev) => ({ ...prev, [name]: data }));
    validation
      .validateAt(name, {
        ...formData,
        [name]: data,
      })
      .then(() => {
        setErrors((prev) => ({ ...prev, [name]: "" }));
      })
      .catch((error) => {
        setErrors((prev) => ({ ...prev, [name]: error.message }));
      });
  };
  // const onSubmit = (onSuccess = () => { }) => {
  //   validation
  //     .validate({ ...formData, product_data: product }, { abortEarly: false })
  //     .then(() => {
  //       setErrors({});
  //       onSuccess({ ...proposalData, ...formData }, { isFormData: true });
  //     })
  //     .catch((error) => {
  //       const newErrors = {};

  //       if (error?.inner && Array.isArray(error.inner)) {
  //         error.inner.forEach((item) => {
  //           if (item?.path) {
  //             newErrors[item.path] = item.message;
  //           }
  //         });
  //       } else if (error?.path) {
  //         // fallback for single error
  //         newErrors[error.path] = error.message;
  //       }

  //       setErrors(newErrors);
  //     });
  // };
  const onSubmit = (onSuccess) => {

    validation
      .validate(
        { ...formData, product_data: product },
        { abortEarly: false }
      )
      .then(() => {
        setErrors({});
        onSuccess({ ...proposalData, ...formData }, { isFormData: true });
      })
      .catch((err) => {
        console.log("validation failed", err);
        const newErrors = {};
        err.inner?.forEach((e) => {
          if (e.path) newErrors[e.path] = e.message;
        });
        setErrors(newErrors);
      });
  };
  const getFieldProps = (docType) => {
    switch (docType) {
      case "PROOF OF POSSESSION OF AADHAR":
        return { maxLength: 4, tooltip: "Enter last 4 digit number" };
      case "PAN":
        return { maxLength: 10, tooltip: "" };
      case "Passport":
        return { maxLength: 8, tooltip: "" };
      case "Voter ID":
        return { maxLength: 10, tooltip: "" };
      default:
        return { maxLength: 12, tooltip: "" };
    }
  };
  const poiFieldProps = getFieldProps(formData?.POI_Type);
  const poaFieldProps = getFieldProps(formData?.POA_Type);
  // Allowed file formats
  const allowedFormats = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/bmp",
    "application/pdf",
  ];

  // Reusable file handler
  const handleFileChange = (fieldName, event) => {
    const file = event.target.files[0];

    if (!file) return;

    // Validate file type
    if (!allowedFormats.includes(file.type)) {
      alert("Only JPG, JPEG, PNG, BMP, PDF files are allowed");
      event.target.value = "";
      return;
    }

    // Optional: validate file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      alert("File size must be less than 5MB");
      event.target.value = "";
      return;
    }

    onChange(fieldName, file);
  };
  // const { maxLength, tooltip } = getPOIFieldProps(formData?.POI_Type ? formData?.POI_Type : formData?.POA_Type);
  return (
    <>
      {isLoading && <Loader />}
      <ClosedForm
        title={"CKYC Details"}
        index={4}
        next={"Final Submit"}
        onSubmit={onSubmit}
        finalSubmit={finalSubmit}
        isFormData
      >
        <InputWrapper>
          <RadioButton
            items={yesNoItems}
            label="Do you have CKYC no.?"
            onChange={(val) => {
              onChange("is_ckyc_no", val);
            }}
            defaultValue={formData?.is_ckyc_no}
          />
        </InputWrapper>

        {formData?.is_ckyc_no === "Y" && (
          <>
            <InputWrapper>
              <TextInput
                size={"medium"}
                label={"CKYC Number"}
                error={errors?.ckyc_no}
                onInput={onInputPhone}
                maxLength={14}
                onChange={(e) => {
                  onChange("ckyc_no", e.target.value);
                }}
                value={formData?.ckyc_no}
              />
            </InputWrapper>
            {product?.INSURANCE_SLUG === "icici_lombard_general" && (
              <InputWrapper>
                <DatePicker
                  label={"ckyc dob"}
                  size="medium"
                  maxDate={moment().subtract(18, "years")}
                  minDate={moment().subtract(60, "years")}
                  handleChange={(val) => {
                    onChange("ckyc_dob", val);
                  }}
                  readOnly={proposalData?.ckyc}
                  outputFormat="YYYY-MM-DD"
                  value={formData?.ckyc_dob}
                  error={errors?.ckyc_dob}
                />
              </InputWrapper>
            )}
          </>
        )}

        {formData?.is_ckyc_no === "N" &&
          product?.INSURANCE_SLUG === "icici_lombard_general" && (
            <>
              <InputWrapper>
                <AutoCompleteSelect
                  size="medium"
                  label="Method of Verification"
                  error={errors?.method_of_verification}
                  handleChange={(val) => {
                    if (val) {
                      onChange("method_of_verification", val.OPTION_KEY);
                    } else {
                      onChange("method_of_verification", "");
                    }
                  }}
                  _key="OPTION_VAL"
                  options={verification_methods_icici}
                  // selectedValue={
                  //   formData?.method_of_verification
                  //     ? {
                  //       OPTION_KEY: formData.method_of_verification,
                  //       OPTION_VAL:
                  //         verification_methods_icici.find(
                  //           (item) =>
                  //             item.OPTION_KEY ===
                  //             formData.method_of_verification
                  //         )?.OPTION_VAL || "",
                  //     }
                  //     : null
                  // }
                  selectedValue={
                    verification_methods.find(
                      (item) =>
                        item.OPTION_KEY === formData?.method_of_verification
                    ) || null
                  }
                  getOptionLabel={(item) => item.OPTION_VAL || ""}
                  getOptionSelected={(item, val) =>
                    item.OPTION_KEY === val?.OPTION_KEY
                  }
                />
              </InputWrapper>

              {formData.method_of_verification === "pancard" && (
                <>
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      label="Pan Number"
                      error={errors?.ckyc_pan_no}
                      onInput={uppercase}
                      onChange={(e) => {
                        onChange("ckyc_pan_no", e.target.value);
                      }}
                      maxLength={10}
                      value={formData?.ckyc_pan_no}
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <DatePicker
                      label="Date of Birth"
                      size="medium"
                      maxDate={moment().subtract(18, "years")}
                      minDate={moment().subtract(60, "years")}
                      handleChange={(val) => {
                        onChange("pan_dob", val);
                      }}
                      readOnly={proposalData?.ckyc}
                      outputFormat="YYYY-MM-DD"
                      value={formData?.pan_dob}
                      error={errors?.pan_dob}
                    />
                  </InputWrapper>
                </>
              )}

              {formData.method_of_verification === "aadharcard" && (
                <>
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      label="Aadhar Number"
                      error={errors?.aadhaar_number}
                      onChange={(e) => {
                        onChange("aadhaar_number", e.target.value);
                      }}
                      maxLength={12}
                      value={formData?.aadhaar_number}
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      label="Aadhar Name"
                      error={errors?.full_name}
                      onChange={(e) => {
                        onChange("full_name", e.target.value);
                      }}
                      maxLength={56}
                      value={formData?.full_name}
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <DatePicker
                      label="Date of Birth"
                      size="medium"
                      maxDate={moment().subtract(18, "years")}
                      minDate={moment().subtract(60, "years")}
                      handleChange={(val) => {
                        onChange("aadhaar_dob", val);
                      }}
                      readOnly={proposalData?.ckyc}
                      outputFormat="YYYY-MM-DD"
                      value={formData?.aadhaar_dob}
                      error={errors?.aadhaar_dob}
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <RadioButton
                      label="Gender"
                      items={genderOptions}
                      defaultValue={formData?.ckyc_gender}
                      onChange={(val) => onChange("ckyc_gender", val)}
                    />
                  </InputWrapper>
                </>
              )}

              {formData.method_of_verification === "drivingdetails" && (
                <>
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      label="Driving License Number"
                      error={errors?.dl_number}
                      onChange={(e) => {
                        onChange("dl_number", e.target.value);
                      }}
                      maxLength={16}
                      value={formData?.dl_number}
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <DatePicker
                      label="Driving License Date of Birth"
                      size="medium"
                      maxDate={moment().subtract(18, "years")}
                      minDate={moment().subtract(60, "years")}
                      handleChange={(val) => {
                        onChange("dl_dob", val);
                      }}
                      readOnly={proposalData?.ckyc}
                      outputFormat="YYYY-MM-DD"
                      value={formData?.dl_dob}
                      error={errors?.dl_dob}
                    />
                  </InputWrapper>
                </>
              )}

              {formData.method_of_verification === "passportdetails" && (
                <>
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      label="Passport Number"
                      error={errors?.file_number}
                      onChange={(e) => {
                        onChange("file_number", e.target.value);
                      }}
                      maxLength={12}
                      value={formData?.file_number}
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <DatePicker
                      label="Passport Date of Birth"
                      size="medium"
                      maxDate={moment().subtract(18, "years")}
                      minDate={moment().subtract(60, "years")}
                      handleChange={(val) => {
                        onChange("passport_dob", val);
                      }}
                      readOnly={proposalData?.ckyc}
                      outputFormat="YYYY-MM-DD"
                      value={formData?.passport_dob}
                      error={errors?.passport_dob}
                    />
                  </InputWrapper>
                </>
              )}
              {formData.method_of_verification === "icicidocument" && (
                <>
                  <InputWrapper>
                    <AutoCompleteSelect
                      size={"medium"}
                      label={"Address Proof"}
                      _key={"OPTION_VAL"}
                      options={icicipoadocuments}
                      error={errors?.address_proof}
                      handleChange={(val) => {
                        onChange("address_proof", val.OPTION_KEY);
                      }}
                      value={formData?.address_proof}
                      // selectedValue={
                      //   formData?.address_proof && {
                      //     OPTION_KEY: formData?.address_proof,
                      //     OPTION_VAL:
                      //       (formData?.address_proof &&
                      //         icicipoadocuments?.find(
                      //           (item) =>
                      //             item.OPTION_KEY === formData?.address_proof
                      //         )?.OPTION_VAL) ||
                      //       "",
                      //   }
                      // }
                      selectedValue={
                        documents?.find(
                          (item) => item.OPTION_KEY === formData?.address_proof
                        ) || null
                      }
                      getOptionLabel={(item) => item.OPTION_VAL || ""}
                      getOptionSelected={(item, val) =>
                        item.OPTION_KEY === val.OPTION_KEY
                      }
                      // Ensure autoComplete is passed as a string value, e.g., "on" or "off"
                      autoComplete="off" // <-- Modify this line as needed
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <TextInput
                      size={"medium"}
                      type="file"
                      label={"Address Proof both Front & backside Document"}
                      error={errors?.address_proof_frontback_doc}
                      onChange={(e) => {
                        onChange(
                          "address_proof_frontback_doc",
                          e.target.files[0]
                        );
                      }}
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <AutoCompleteSelect
                      size={"medium"}
                      label={"Identity Proof"}
                      _key={"OPTION_VAL"}
                      options={icicipoidocuments}
                      error={errors?.identity_proof}
                      handleChange={(val) => {
                        onChange("identity_proof", val.OPTION_KEY);
                      }}
                      value={formData?.identity_proof}
                      // selectedValue={
                      //   formData?.identity_proof && {
                      //     OPTION_KEY: formData?.identity_proof,
                      //     OPTION_VAL:
                      //       (formData?.identity_proof &&
                      //         icicipoidocuments?.find(
                      //           (item) =>
                      //             item.OPTION_KEY === formData?.identity_proof
                      //         )?.OPTION_VAL) ||
                      //       "",
                      //   }
                      // }
                      selectedValue={
                        documents?.find(
                          (item) => item.OPTION_KEY === formData?.identity_proof
                        ) || null
                      }
                      getOptionLabel={(item) => item.OPTION_VAL || ""}
                      getOptionSelected={(item, val) =>
                        item.OPTION_KEY === val.OPTION_KEY
                      }
                      // Ensure autoComplete is passed as a string value, e.g., "on" or "off"
                      autoComplete="off" // <-- Modify this line as needed
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <TextInput
                      size={"medium"}
                      type="file"
                      label={"Identity Proof Front & backside Document"}
                      error={errors?.identity_proof_frontback_doc}
                      onChange={(e) => {
                        onChange(
                          "identity_proof_frontback_doc",
                          e.target.files[0]
                        );
                      }}
                    />
                  </InputWrapper>
                </>
              )}
            </>
          )}
        {formData?.is_ckyc_no === "N" &&
          product?.INSURANCE_SLUG === "shri_ram" && (
            <>
              {/* Proof of Identity */}
              <InputWrapper>
                <AutoCompleteSelect
                  label="Proof of Identity"
                  options={POI}
                  size="medium"
                  _key="OPTION_VAL"
                  error={errors?.POI_Type}
                  handleChange={(value) => {
                    if (value) {
                      onChange("POI_Type", value.OPTION_KEY);
                      onChange("POI_ID", "");
                    }
                  }}
                  selectedValue={
                    POI.find((item) => item.OPTION_KEY === formData?.POI_Type) || null
                  }
                  getOptionLabel={(option) => option.OPTION_VAL || ""}
                  getOptionSelected={(option, value) =>
                    option.OPTION_KEY === value.OPTION_KEY
                  }
                />
              </InputWrapper>

              {/* Identity Proof Number */}
              <InputWrapper>
                {/* POI_ID */}
                <Tooltip title={poiFieldProps.tooltip || ""} arrow>
                  <div>
                    <TextInput
                      size="medium"
                      label="Identity Proof Number"
                      error={errors?.POI_ID}
                      onInput={uppercase}
                      onChange={(e) => {
                        onChange("POI_ID", e.target.value);
                      }}
                      maxLength={poiFieldProps.maxLength}
                      value={formData?.POI_ID}
                    />
                  </div>
                </Tooltip>
              </InputWrapper>

              {/* Proof of Identity Document */}
              <InputWrapper>
                <TextInput
                  size="medium"
                  type="file"
                  label="Proof of Identity Doc"
                  error={error?.POI_DocumentFile}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    const isShriram =
                      product?.INSURANCE_SLUG?.toLowerCase() === "shri_ram"; // 🔹 make sure spelling matches actual slug

                    // Reset previous error
                    setError((prev) => ({ ...prev, POI_DocumentFile: "" }));

                    if (file) {
                      const allowedFileTypes = isShriram
                        ? [
                          "application/pdf",
                          "image/png",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ]
                        : ["application/pdf", "image/jpeg", "image/png",];

                      // ❌ Invalid file type
                      if (!allowedFileTypes.includes(file.type)) {
                        setError((prev) => ({
                          ...prev,
                          POI_DocumentFile: isShriram
                            ? "Allowed formats: .pdf, .png, .xlsx."
                            : "Allowed formats: .pdf, .jpg, .png .xlsx only.",
                        }));
                        onChange("POI_DocumentFile", null);
                        e.target.value = ""; // clear invalid file
                        return;
                      }

                      // ❌ File too large
                      if (file.size > 2 * 1024 * 1024) {
                        setError((prev) => ({
                          ...prev,
                          POI_DocumentFile: "File size exceeds 2MB.",
                        }));
                        onChange("POI_DocumentFile", null);
                        e.target.value = "";
                        return;
                      }

                      // ✅ Valid file
                      onChange("POI_DocumentFile", file);
                    } else {
                      onChange("POI_DocumentFile", null);
                    }
                  }}
                />
              </InputWrapper>



              {/* POA_Type Autocomplete */}
              <InputWrapper>
                <AutoCompleteSelect
                  size="medium"
                  label="Proof of Address"
                  _key="OPTION_VAL"
                  options={POA}
                  error={errors?.POA_Type}
                  handleChange={(val) => {
                    if (val) {
                      onChange("POA_Type", val.OPTION_KEY);
                      onChange("POA_ID", "");
                    }
                  }}
                  selectedValue={
                    POA.find((item) => item.OPTION_KEY === formData?.POA_Type) || null
                  }
                  getOptionLabel={(item) => item.OPTION_VAL || ""}
                  getOptionSelected={(item, val) =>
                    item.OPTION_KEY === val.OPTION_KEY
                  }
                />
              </InputWrapper>

              {/* POA_ID */}
              <InputWrapper>
                <Tooltip title={poaFieldProps.tooltip || ""} arrow>
                  <div>
                    <TextInput
                      size="medium"
                      label="Proof of Address Number"
                      error={errors?.POA_ID}
                      onInput={uppercase}
                      onChange={(e) => {
                        onChange("POA_ID", e.target.value);
                      }}
                      maxLength={poaFieldProps.maxLength}
                      value={formData?.POA_ID}
                    />
                  </div>
                </Tooltip>
              </InputWrapper>

              {/* Proof of Address Document */}
              <InputWrapper>
                <TextInput
                  size="medium"
                  type="file"
                  label="Proof of Address Doc"
                  error={error?.POA_DocumentFile}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    const isShriram =
                      product?.INSURANCE_SLUG?.toLowerCase() === "shri_ram";

                    // Reset old error
                    setError((prev) => ({ ...prev, POA_DocumentFile: "" }));

                    if (file) {
                      const allowedFileTypes = isShriram
                        ? [
                          "application/pdf",
                          "image/png",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ]
                        : ["application/pdf", "image/jpeg", "image/png", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ];

                      // ❌ Invalid type
                      if (!allowedFileTypes.includes(file.type)) {
                        setError((prev) => ({
                          ...prev,
                          POA_DocumentFile: isShriram
                            ? "Allowed formats: .pdf, .png, .xlsx"
                            : "Allowed formats: .pdf, .jpg, .png",
                        }));
                        onChange("POA_DocumentFile", null);
                        e.target.value = ""; // ⬅️ clears file input instantly
                        return;
                      }

                      // ❌ Too large
                      if (file.size > 2 * 1024 * 1024) {
                        setError((prev) => ({
                          ...prev,
                          POA_DocumentFile: "File size exceeds 2MB.",
                        }));
                        onChange("POA_DocumentFile", null);
                        e.target.value = "";
                        return;
                      }

                      // ✅ Valid file
                      onChange("POA_DocumentFile", file);
                    } else {
                      onChange("POA_DocumentFile", null);
                    }
                  }}
                />
              </InputWrapper>

              {/* Photo */}
              <InputWrapper>
                <TextInput
                  size="medium"
                  type="file"
                  label="Photo"
                  name="Insured_photo"
                  error={error?.Insured_photo}
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    const isShriram =
                      product?.INSURANCE_SLUG?.toLowerCase() === "shri_ram";

                    // Reset old error
                    setError((prev) => ({ ...prev, Insured_photo: "" }));

                    if (file) {
                      const allowedFileTypes = isShriram
                        ? [
                          "application/pdf",
                          "image/png",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ]
                        : ["application/pdf", "image/jpeg", "image/png", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ];

                      // ❌ Invalid type
                      if (!allowedFileTypes.includes(file.type)) {
                        setError((prev) => ({
                          ...prev,
                          Insured_photo: isShriram
                            ? "Allowed formats: .pdf, .png, .xlsx."
                            : "Allowed formats: .pdf, .jpg, .png",
                        }));
                        onChange("Insured_photo", null);
                        e.target.value = ""; // clear invalid file
                        return;
                      }

                      // ❌ Too large
                      if (file.size > 2 * 1024 * 1024) {
                        setError((prev) => ({
                          ...prev,
                          Insured_photo: "File size exceeds 2MB.",
                        }));
                        onChange("Insured_photo", null);
                        e.target.value = "";
                        return;
                      }

                      // ✅ Valid file
                      onChange("Insured_photo", file);
                    } else {
                      onChange("Insured_photo", null);
                    }
                  }}
                />
              </InputWrapper>

            </>
          )}

        {formData?.is_ckyc_no === "N" &&
          product?.INSURANCE_SLUG !== "icici_lombard_general" &&
          product?.INSURANCE_SLUG !== "shri_ram" && (
            <>
              <InputWrapper>
                <AutoCompleteSelect
                  size="medium"
                  label="Method of Verification"
                  error={errors?.method_of_verification}
                  handleChange={(val) => {
                    if (val) {
                      onChange("method_of_verification", val.OPTION_KEY);
                    } else {
                      onChange("method_of_verification", "");
                    }
                  }}
                  _key="OPTION_VAL"
                  options={verification_methods}
                  // selectedValue={
                  //   formData?.method_of_verification
                  //     ? {
                  //       OPTION_KEY: formData.method_of_verification,
                  //       OPTION_VAL:
                  //         verification_methods.find(
                  //           (item) =>
                  //             item.OPTION_KEY === formData.method_of_verification
                  //         )?.OPTION_VAL || "",
                  //     }
                  //     : null
                  // }
                  selectedValue={
                    verification_methods.find(
                      (item) =>
                        item.OPTION_KEY === formData?.method_of_verification
                    ) || null
                  }
                  getOptionLabel={(item) => item.OPTION_VAL || ""}
                  getOptionSelected={(item, val) =>
                    item.OPTION_KEY === val?.OPTION_KEY
                  }
                />
              </InputWrapper>

              {/* PAN */}
              {formData.method_of_verification === "pan" && (
                <InputWrapper>
                  <TextInput
                    size="medium"
                    label="Pan Number"
                    error={errors?.pan_no}
                    onInput={(e) => {
                      // Allow only alphabets and numbers
                      e.target.value = e.target.value
                        .replace(/[^a-zA-Z0-9]/g, "")
                        .toUpperCase()
                        .slice(0, 10);
                    }}
                    onChange={(e) =>
                      onChange("pan_no", e.target.value.toUpperCase())
                    }
                    maxLength={10}
                    value={formData?.pan_no}
                  />
                </InputWrapper>
              )}

              {/* Document Upload */}
              {formData.method_of_verification === "doc" && (
                <>
                  <InputWrapper>
                    <AutoCompleteSelect
                      size="medium"
                      label="Address Proof"
                      _key="OPTION_VAL"
                      options={documents}
                      error={errors?.address_proof}
                      handleChange={(val) =>
                        onChange("address_proof", val.OPTION_KEY)
                      }
                      // selectedValue={
                      //   formData?.address_proof && {
                      //     OPTION_KEY: formData?.address_proof,
                      //     OPTION_VAL:
                      //       documents?.find(
                      //         (item) =>
                      //           item.OPTION_KEY === formData?.address_proof
                      //       )?.OPTION_VAL,
                      //   }
                      // }/
                      selectedValue={
                        documents?.find(
                          (item) => item.OPTION_KEY === formData?.address_proof
                        ) || null
                      }
                      getOptionLabel={(item) => item.OPTION_VAL || ""}
                      getOptionSelected={(item, val) =>
                        item.OPTION_KEY === val.OPTION_KEY
                      }
                      autoComplete="off"
                    />
                  </InputWrapper>

                  {/* Address Proof Front */}
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      type="file"
                      label="Address Proof Frontside Document"
                      error={errors?.address_proof_front_doc}
                      inputProps={{
                        accept: ".jpg,.jpeg,.png,.bmp,.pdf",
                      }}
                      onChange={(e) =>
                        handleFileChange(
                          "address_proof_front_doc",
                          e
                        )
                      }
                    />
                  </InputWrapper>

                  {/* Address Proof Back */}
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      type="file"
                      label="Address Proof Backside Document"
                      error={errors?.address_proof_back_doc}
                      inputProps={{
                        accept: ".jpg,.jpeg,.png,.bmp,.pdf",
                      }}
                      onChange={(e) =>
                        handleFileChange(
                          "address_proof_back_doc",
                          e
                        )
                      }
                    />
                  </InputWrapper>

                  {/* Identity Proof */}
                  <InputWrapper>
                    <AutoCompleteSelect
                      size="medium"
                      label="Identity Proof"
                      _key="OPTION_VAL"
                      options={documents}
                      error={errors?.identity_proof}
                      handleChange={(val) =>
                        onChange("identity_proof", val.OPTION_KEY)
                      }
                      // selectedValue={
                      //   formData?.identity_proof && {
                      //     OPTION_KEY: formData?.identity_proof,
                      //     OPTION_VAL:
                      //       documents?.find(
                      //         (item) =>
                      //           item.OPTION_KEY === formData?.identity_proof
                      //       )?.OPTION_VAL,
                      //   }
                      // }
                      selectedValue={
                        documents?.find(
                          (item) => item.OPTION_KEY === formData?.identity_proof
                        ) || null
                      }
                      getOptionLabel={(item) => item.OPTION_VAL || ""}
                      getOptionSelected={(item, val) =>
                        item.OPTION_KEY === val.OPTION_KEY
                      }
                      autoComplete="off"
                    />
                  </InputWrapper>

                  {/* Identity Proof Front */}
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      type="file"
                      label="Identity Proof Frontside Document"
                      error={errors?.identity_proof_front_doc}
                      inputProps={{
                        accept: ".jpg,.jpeg,.png,.bmp,.pdf",
                      }}
                      onChange={(e) =>
                        handleFileChange(
                          "identity_proof_front_doc",
                          e
                        )
                      }
                    />
                  </InputWrapper>

                  {/* Identity Proof Back */}
                  <InputWrapper>
                    <TextInput
                      size="medium"
                      type="file"
                      label="Identity Proof Backside Document"
                      error={errors?.identity_proof_back_doc}
                      inputProps={{
                        accept: ".jpg,.jpeg,.png,.bmp,.pdf",
                      }}
                      onChange={(e) =>
                        handleFileChange(
                          "identity_proof_back_doc",
                          e
                        )
                      }
                    />
                  </InputWrapper>
                </>
              )}

              {/* Photo */}
              <InputWrapper>
                <TextInput
                  size="medium"
                  type="file"
                  label="Photo"
                  error={errors?.photo_doc}
                  inputProps={{
                    accept: ".jpg,.jpeg,.png,.bmp,.pdf",
                  }}
                  onChange={(e) =>
                    handleFileChange("photo_doc", e)
                  }
                />
              </InputWrapper>
            </>
          )}
      </ClosedForm>
    </>
  );
};

export default CKYCDetails;

const verification_methods = [
  {
    OPTION_KEY: "pan",
    OPTION_VAL: "PAN Number",
  },
  {
    OPTION_KEY: "doc",
    OPTION_VAL: "Physical Documents",
  },
];

const verification_methods_icici = [
  {
    OPTION_KEY: "pancard",
    OPTION_VAL: "Pancard Details",
  },
  {
    OPTION_KEY: "aadharcard",
    OPTION_VAL: "Aadhar Details",
  },
  {
    OPTION_KEY: "drivingdetails",
    OPTION_VAL: "Driving License",
  },
  {
    OPTION_KEY: "passportdetails",
    OPTION_VAL: "Passport Details",
  },
  {
    OPTION_KEY: "icicidocument",
    OPTION_VAL: "Physical Documents",
  },
];
const documents = [
  {
    OPTION_KEY: "D20",
    OPTION_VAL: "CGHS ECHS CARD",
  },
  {
    OPTION_KEY: "D21",
    OPTION_VAL: "PHOTO CREDIT CARD",
  },
  {
    OPTION_KEY: "D22",
    OPTION_VAL: "IT PROOF",
  },
  {
    OPTION_KEY: "D23",
    OPTION_VAL: "PHOTO PENSIONER CARD",
  },
  {
    OPTION_KEY: "D24",
    OPTION_VAL: "BANK STATEMENT",
  },
  {
    OPTION_KEY: "D25",
    OPTION_VAL: "AADHAAR IMAGE",
  },
  {
    OPTION_KEY: "D26",
    OPTION_VAL: "DRIVING LICENSE IMAGE",
  },
  {
    OPTION_KEY: "D27",
    OPTION_VAL: "VOTER ID IMAGE",
  },
  {
    OPTION_KEY: "D28",
    OPTION_VAL: "PASSPORT IMAGE",
  },
];

const icicipoidocuments = [
  {
    OPTION_KEY: "PAN",
    OPTION_VAL: "PANCARD",
  },
  {
    OPTION_KEY: "AADHAAR",
    OPTION_VAL: "AADHAR",
  },
  {
    OPTION_KEY: "VOTERID",
    OPTION_VAL: "VOTERID",
  },
  {
    OPTION_KEY: "DL",
    OPTION_VAL: "DRIVINGLICENSE",
  },
  {
    OPTION_KEY: "PASSPORT",
    OPTION_VAL: "PASSPORT",
  },
];

const icicipoadocuments = [
  {
    OPTION_KEY: "PAN",
    OPTION_VAL: "PANCARD",
  },
  {
    OPTION_KEY: "AADHAAR",
    OPTION_VAL: "AADHAR",
  },
  {
    OPTION_KEY: "VOTERID",
    OPTION_VAL: "VOTERID",
  },
  {
    OPTION_KEY: "DL",
    OPTION_VAL: "DRIVINGLICENSE",
  },
];

const genderOptions = [
  {
    label: "Male",
    value: "M",
  },
  {
    label: "Female",
    value: "F",
  },
];

const POI = [
  {
    OPTION_KEY: "PAN",
    OPTION_VAL: "PAN",
  },
  {
    OPTION_KEY: "PROOF OF POSSESSION OF AADHAR",
    OPTION_VAL: "PROOF OF POSSESSION OF AADHAR",
  },
  {
    OPTION_KEY: "Passport",
    OPTION_VAL: "Passport",
  },
  {
    OPTION_KEY: "Voter ID",
    OPTION_VAL: "Voter ID",
  },
];

const POA = [
  {
    OPTION_KEY: "PROOF OF POSSESSION OF AADHAR",
    OPTION_VAL: "PROOF OF POSSESSION OF AADHAR",
  },
  {
    OPTION_KEY: "Passport",
    OPTION_VAL: "Passport",
  },
  {
    OPTION_KEY: "Voter ID",
    OPTION_VAL: "Voter ID",
  },
];
